module.exports = __webpack_public_path__ + "media/images/emblems/Les_Verrieres-coat_of_arms-07e5997253c1416274efceeb0df52efb.svg";